/** The one type a PDF reader, a stamp or a split works on. */
export const PDF_MIME_TYPE = 'application/pdf'

export const DOCUMENT_TAGS = [
  // Customer-uploadable required slots
  'EXPOSE',
  'LIVING_AREA_CALCULATION',
  'FLOOR_PLAN',
  'ENERGY_CERTIFICATE',
  'BUILDING_SECTIONS',
  'EXPERT_REPORT',
  'AIRTIGHTNESS_TEST',
  // Internal-only (admin-uploadable)
  'OFFER',
  'COST_ESTIMATE',
  'CONTRACT',
  'INVOICE',
  'MISC',
] as const

export type DocumentTag = (typeof DOCUMENT_TAGS)[number]

export const REQUIRED_DOCUMENT_TAGS: DocumentTag[] = [
  'EXPOSE',
  'LIVING_AREA_CALCULATION',
  'FLOOR_PLAN',
  'ENERGY_CERTIFICATE',
  'BUILDING_SECTIONS',
  'EXPERT_REPORT',
  'AIRTIGHTNESS_TEST',
]

export const ALLOWED_DOCUMENT_MIME_TYPES = [
  // Images
  'image/jpeg',
  'image/png',
  'image/webp',
  // PDF
  'application/pdf',
  // Microsoft Office
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  // LibreOffice / OpenDocument
  'application/vnd.oasis.opendocument.text',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.oasis.opendocument.presentation',
] as const
